import MastercardIcon from "../components/Icons/CreditCards/Mastercard";
import CapitalOneIcon from "../components/Icons/CreditCards/CapitalOne";
import ChaseBank from "../components/Icons/CreditCards/ChaseBank";
import DinersClubIcon from "../components/Icons/CreditCards/DinersClub";
import DiscoverIcon from "../components/Icons/CreditCards/Discover";
import JCBIcon from "../components/Icons/CreditCards/JCB";
import UnionPayIcon from "../components/Icons/CreditCards/UnionPay";
import VisaIcon from "../components/Icons/CreditCards/Visa";
import AmexIcon from "../components/Icons/CreditCards/Amex";

export default function useCreditCard() {
    interface CardImages {
        amex: React.ReactElement;
        capitalone: React.ReactElement;
        chase: React.ReactElement;
        dinersclub: React.ReactElement;
        discover: React.ReactElement;
        hipercard: React.ReactElement;
        jcb: React.ReactElement;
        unionpay: React.ReactElement;
        mastercard: React.ReactElement;
        placeholder: React.ReactElement;
        visa: React.ReactElement;
    }

    const cardImages: CardImages = {
        mastercard: <MastercardIcon />,
        capitalone: <CapitalOneIcon />,
        chase: <ChaseBank />,
        amex: <AmexIcon />,
        dinersclub: <DinersClubIcon />,
        discover: <DiscoverIcon />,
        hipercard: <MastercardIcon />,
        jcb: <JCBIcon />,
        unionpay: <UnionPayIcon />,
        visa: <VisaIcon />,
        placeholder: <div />,
    };

    return {
        cardImages,
    };
}
